import { render, staticRenderFns } from "./CustomerOrderTable.vue?vue&type=template&id=79384d74"
import script from "./CustomerOrderTable.vue?vue&type=script&lang=js"
export * from "./CustomerOrderTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderTable.vue?vue&type=style&index=0&id=79384d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports